import React from 'react';
import styled from 'styled-components';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { BuildPage, InvestPage, ChartsPage, AssetPage } from 'src/pages';
import { useQuery } from 'react-query';
import { queryOptions } from '~/shared/constants';
import { fetchNavHirarchy } from '~/shared/services/api';

const Root = styled.div`
  flex: 1;
  overflow-x: auto;
`;

export default function Routes() {
  const { data, error } = useQuery(fetchNavHirarchy.key, fetchNavHirarchy, queryOptions);
  const navHirarchy = data?.data;

  if (error) return <div>error {(error as unknown as any).message}</div>;

  if (!navHirarchy) return <div></div>;

  const flattendRoutes = navHirarchy.reduce((arr: any[], curr: any) => {
    return arr.concat(curr.type === 'heatmap' ? curr.categories : curr);
  }, []);

  return (
    <Root>
      <RouterRoutes>
        <Route path="/DashboardsApps/:subcategory" element={<ChartsPage navHirarchy={flattendRoutes} />} />
        <Route
          path="/:category/:subcategory/:subsubcategory/:prism"
          element={<ChartsPage navHirarchy={flattendRoutes} />}
        />
        <Route path="/:category/:subcategory/:prism" element={<ChartsPage navHirarchy={flattendRoutes} />} />
        <Route path="/:category/:prism" element={<ChartsPage navHirarchy={flattendRoutes} />} />
        <Route
          path="/"
          element={
            <Navigate
              to={
                navHirarchy?.[0]?.categories?.[0]?.items?.[0]?.items?.[0].items?.[0]?.id
                  ? navHirarchy?.[0]?.categories?.[0]?.name +
                    '/' +
                    navHirarchy?.[0]?.categories?.[0]?.items?.[0]?.name +
                    '/' +
                    navHirarchy?.[0]?.categories?.[0]?.items?.[0]?.items?.[0]?.name +
                    '/' +
                    navHirarchy?.[0]?.categories?.[0]?.items?.[0]?.items?.[0].items?.[0]?.id
                  : navHirarchy?.[0]?.categories?.[0]?.name +
                    '/' +
                    navHirarchy?.[0]?.categories?.[0]?.items?.[0]?.name +
                    '/' +
                    navHirarchy?.[0]?.categories?.[0]?.items?.[0]?.items?.[0]?.id
              }
            ></Navigate>
          }
        />
        <Route path="*" element={<div>404 Not found</div>} />
      </RouterRoutes>
    </Root>
  );
}
